//node_modules
import { useMemo } from "react";

//libs
import getPagingRange from "@adjust/website/libs/helper/getPageRange";

//types
import type { PaginationState } from "./usePaginationHandler";

function usePaginationRange(handler: PaginationState, maxButtons: number) {
  const page = handler.getPage();
  const pageCount = handler.getPageCount();
  return useMemo(() => getPagingRange(page, pageCount, maxButtons), [page, pageCount, maxButtons]);
}

export default usePaginationRange;
